import styled from "styled-components";

import { Tab } from "@libraries/mui";

import { windowWidth } from "@styles/global";

const TabContainer = styled(Tab)`
  color: black !important;
  text-transform: none !important;
  padding: 0px 10px !important;
  min-height: 60px !important;
  min-width: 215px !important;
  max-width: 215px !important;

  :hover {
    background-color: #f5f5f5;
  }

  .MuiSvgIcon-root {
    @media (min-width: ${windowWidth.tablet}) {
      width: 0.7em;
      height: 0.7em;
    }

    :hover {
      background-color: rgb(200, 200, 200);
      border-radius: 50%;
    }
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    min-height: 50px !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
`;

const TabName = styled.div`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  /* padding-right: 10px; */
  flex-grow: 1;
  overflow: hidden;

  * {
    align-self: flex-start !important;
  }

  > :first-child {
    font-weight: bold;
    font-size: 15px;
    text-align: start;
  }

  > :last-child {
    font-size: 13.5px;
    text-align: start;
    color: #666666;

    @media (max-width: ${windowWidth.mobile.large}) {
      font-size: 10px;
    }
  }
`;

export { TabContainer, TabName };
